export default __webpack_public_path__ + "static/media/tokenBadgeSilver108@2x.25eab4c6.png";